import 'font-awesome/css/font-awesome.css';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
// Plugins
import 'froala-editor/js/plugins/align.min.js';
// text
import 'froala-editor/css/plugins/colors.min.css';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/special_characters.min.js';
import 'froala-editor/css/plugins/special_characters.min.css';
import 'froala-editor/css/plugins/quick_insert.min.css';
import 'froala-editor/js/plugins/quick_insert.min.js';
// headings
import '@libs/froala/plugins/paragraph_format';
import 'froala-editor/css/plugins/table.min.css';
import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/inline_class.min.js';
import 'froala-editor/js/plugins/inline_style.min.js';
import 'froala-editor/js/plugins/line_breaker.min.js';
import 'froala-editor/css/plugins/line_breaker.min.css';
import 'froala-editor/js/plugins/line_height.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/css/plugins/image.min.css';
import '@libs/froala/ko';

import loadable from '@loadable/component';
import { Box } from '@modusign/design-system';
import { KeyboardEvent, MutableRefObject } from 'react';
import FroalaEditor from 'react-froala-wysiwyg';

import commonConfig from '@libs/froala/commonConfig';
import wrapperStyle from '@libs/froala/wrapperStyle';

import { withForm } from '@app/api/paths';
import { xApiKey } from '@app/constants/apiKey';
import authService from '@app/libs/auth/authService';

const FroalaAdditionalPlugin = loadable.lib(() => {
  // NCP에서는 이미지 업로드를 지원하지 않습니다.
  // 참고: https://www.notion.so/modusign/NCP-7f47537af0e04cef822ce0ec0f108799?pvs=4
  if (process.env.REACT_APP_MODUSIGN_TENANT_ENV !== 'modusign-gov') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return import('froala-editor/js/plugins/image.min.js');
  }

  return Promise.resolve({});
});

// TODO(form): 타이핑
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Editor = any;

interface DraftEditorProps {
  initContent?: string;
  editorRef?: MutableRefObject<Editor>;
}

export default function DraftEditor({ initContent, editorRef }: DraftEditorProps) {
  return (
    <Box
      height="100%"
      sx={wrapperStyle}
      onKeyDown={(e: KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Tab') {
          e.preventDefault();
          editorRef?.current?.commands.indent();
        }
      }}
    >
      <FroalaAdditionalPlugin>
        {() => (
          <FroalaEditor
            config={{
              ...commonConfig,
              imageUploadURL: withForm('/assets/upload'),
              requestHeaders: {
                // TODO(@highcastlee): accessToken 만료 시, 갱신 방법 체크
                Authorization: `Bearer ${authService.getAccessToken()}`,
                'x-api-key': xApiKey,
              },
            }}
            model={initContent}
            onManualControllerReady={({
              initialize,
              getEditor,
            }: {
              initialize: () => void;
              getEditor: () => Editor;
            }) => {
              initialize();
              if (editorRef) {
                editorRef.current = getEditor();
              }
            }}
          />
        )}
      </FroalaAdditionalPlugin>
    </Box>
  );
} //
